import { render, staticRenderFns } from "./DocTypeView.vue?vue&type=template&id=0c62cd6a&scoped=true&"
import script from "./DocTypeView.vue?vue&type=script&lang=ts&"
export * from "./DocTypeView.vue?vue&type=script&lang=ts&"
import style0 from "./DocTypeView.vue?vue&type=style&index=0&id=0c62cd6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62cd6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFadeTransition,VRow,VSpacer})
